import React from 'react';
import PropTypes from 'prop-types';

const Disclaimer = (props) => (
    <div className="w-full text-sm md:text-lg bg-yellow-50 my-6 px-6 py-2 border border-gray-500 text-blue-900">
        {props.children}
    </div>
);

Disclaimer.propTypes = {
    children: PropTypes.any,
};

export default Disclaimer;
